import { render, staticRenderFns } from "./ApplyMaterialMapping.vue?vue&type=template&id=c4892752&scoped=true&"
import script from "./ApplyMaterialMapping.vue?vue&type=script&lang=js&"
export * from "./ApplyMaterialMapping.vue?vue&type=script&lang=js&"
import style0 from "./ApplyMaterialMapping.vue?vue&type=style&index=0&id=c4892752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4892752",
  null
  
)

export default component.exports